/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Meta_TitleInputs */

const en_about_meta_title = /** @type {(inputs: About_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`About Mark Egly | Mark Egly Golf`)
};

const es_about_meta_title = /** @type {(inputs: About_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sobre Mark Egly | Mark Egly Golf`)
};

const de_about_meta_title = /** @type {(inputs: About_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Über Mark Egly | Mark Egly Golf`)
};

const zh_about_meta_title = /** @type {(inputs: About_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`关于 Mark Egly | Mark Egly Golf`)
};

const ar_about_meta_title = /** @type {(inputs: About_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`عن Mark Egly | Mark Egly Golf`)
};

const fr_about_meta_title = /** @type {(inputs: About_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`À propos de Mark Egly | Mark Egly Golf`)
};

const vi_about_meta_title = /** @type {(inputs: About_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Về Mark Egly | Mark Egly Golf`)
};

const sw_about_meta_title = /** @type {(inputs: About_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kuhusu Mark Egly | Mark Egly Golf`)
};

const th_about_meta_title = /** @type {(inputs: About_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เกี่ยวกับ Mark Egly | Mark Egly Golf`)
};

const bs_about_meta_title = /** @type {(inputs: About_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O Marku Eglyju | Mark Egly Golf`)
};

const ja_about_meta_title = /** @type {(inputs: About_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Eglyについて | Mark Egly Golf`)
};

const ko_about_meta_title = /** @type {(inputs: About_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly 소개 | Mark Egly Golf`)
};

const pt_about_meta_title = /** @type {(inputs: About_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sobre Mark Egly | Mark Egly Golf`)
};

const it_about_meta_title = /** @type {(inputs: About_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informazioni su Mark Egly | Mark Egly Golf`)
};

const sv_about_meta_title = /** @type {(inputs: About_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Om Mark Egly | Mark Egly Golf`)
};

const nl_about_meta_title = /** @type {(inputs: About_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Over Mark Egly | Mark Egly Golf`)
};

const da_about_meta_title = /** @type {(inputs: About_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Om Mark Egly | Mark Egly Golf`)
};

const nb_about_meta_title = /** @type {(inputs: About_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Om Mark Egly | Mark Egly Golf`)
};

const fi_about_meta_title = /** @type {(inputs: About_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tietoa Mark Eglystä | Mark Egly Golf`)
};

const pl_about_meta_title = /** @type {(inputs: About_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O Marku Eglym | Mark Egly Golf`)
};

const ru_about_meta_title = /** @type {(inputs: About_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`О тренере Mark Egly | Mark Egly Golf`)
};

const tr_about_meta_title = /** @type {(inputs: About_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly Hakkında | Mark Egly Golf`)
};

const hi_about_meta_title = /** @type {(inputs: About_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly के बारे में | Mark Egly Golf`)
};

const id_about_meta_title = /** @type {(inputs: About_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tentang Mark Egly | Mark Egly Golf`)
};

const ms_about_meta_title = /** @type {(inputs: About_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tentang Mark Egly | Mark Egly Golf`)
};

const cs_about_meta_title = /** @type {(inputs: About_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O Marku Eglym | Mark Egly Golf`)
};

const el_about_meta_title = /** @type {(inputs: About_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Σχετικά με τον Mark Egly | Mark Egly Golf`)
};

const he_about_meta_title = /** @type {(inputs: About_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`אודות Mark Egly | Mark Egly Golf`)
};

const af_about_meta_title = /** @type {(inputs: About_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oor Mark Egly | Mark Egly Golf`)
};

const hu_about_meta_title = /** @type {(inputs: About_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Eglyről | Mark Egly Golf`)
};

/**
* | output |
* | --- |
* | "About Mark Egly \| Mark Egly Golf" |
*
* @param {About_Meta_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const about_meta_title = /** @type {((inputs?: About_Meta_TitleInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Meta_TitleInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_about_meta_title(inputs)
	if (locale === "de") return de_about_meta_title(inputs)
	if (locale === "zh") return zh_about_meta_title(inputs)
	if (locale === "ar") return ar_about_meta_title(inputs)
	if (locale === "fr") return fr_about_meta_title(inputs)
	if (locale === "vi") return vi_about_meta_title(inputs)
	if (locale === "sw") return sw_about_meta_title(inputs)
	if (locale === "th") return th_about_meta_title(inputs)
	if (locale === "bs") return bs_about_meta_title(inputs)
	if (locale === "ja") return ja_about_meta_title(inputs)
	if (locale === "ko") return ko_about_meta_title(inputs)
	if (locale === "pt") return pt_about_meta_title(inputs)
	if (locale === "it") return it_about_meta_title(inputs)
	if (locale === "sv") return sv_about_meta_title(inputs)
	if (locale === "nl") return nl_about_meta_title(inputs)
	if (locale === "da") return da_about_meta_title(inputs)
	if (locale === "nb") return nb_about_meta_title(inputs)
	if (locale === "fi") return fi_about_meta_title(inputs)
	if (locale === "pl") return pl_about_meta_title(inputs)
	if (locale === "ru") return ru_about_meta_title(inputs)
	if (locale === "tr") return tr_about_meta_title(inputs)
	if (locale === "hi") return hi_about_meta_title(inputs)
	if (locale === "id") return id_about_meta_title(inputs)
	if (locale === "ms") return ms_about_meta_title(inputs)
	if (locale === "cs") return cs_about_meta_title(inputs)
	if (locale === "el") return el_about_meta_title(inputs)
	if (locale === "he") return he_about_meta_title(inputs)
	if (locale === "af") return af_about_meta_title(inputs)
	if (locale === "hu") return hu_about_meta_title(inputs)
	return en_about_meta_title(inputs)
});